import { useMemo, useState, useEffect } from "react";
import { db } from "../../firebase/config";
import { useLocation } from "react-router-dom";
import { collection, onSnapshot, query } from "firebase/firestore";
import "./Produtos.css";

export default function PgProdutos({ onOpenProduct }) {
  const [produtosBanco, setProdutosBanco] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("todos");
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const catUrl = params.get("categoria");

    if (catUrl) {
      setActiveCategory(catUrl.toLowerCase());
    } else {
      setActiveCategory("todos");
    }
  }, [location]);

  // Busca real-time do Firestore
  useEffect(() => {
    const q = query(collection(db, "produtos"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setProdutosBanco(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Gera categorias dinamicamente a partir dos produtos do banco
  const categorias = useMemo(() => {
    const produtosComEstoque = produtosBanco.filter(
      (p) => Number(p.estoque) > 0,
    );
    const unique = Array.from(
      new Set(produtosComEstoque.map((p) => p.categoria).filter(Boolean)),
    );

    return [
      { chave: "todos", label: "Todos" },
      ...unique.map((cat) => {
        const item = produtosComEstoque.find((p) => p.categoria === cat);
        return {
          chave: cat,
          label: item?.categoriaLabel || cat,
        };
      }),
    ];
  }, [produtosBanco]);

  const produtosFiltrados = useMemo(() => {
    const pesquisa = searchQuery.trim().toLowerCase();
    return produtosBanco
      .filter((p) => Number(p.estoque) > 0)
      .filter((p) => {
        const correspondeCategoria =
          activeCategory === "todos" || p.categoria === activeCategory;
        const correspondeBusca =
          pesquisa.length === 0 ||
          [p.nome || "", p.descricao || "", p.categoriaLabel || ""]
            .join(" ")
            .toLowerCase()
            .includes(pesquisa);
        return correspondeCategoria && correspondeBusca;
      });
  }, [activeCategory, searchQuery, produtosBanco]);

  if (loading)
    return <div className="loading-produtos">Carregando catálogo...</div>;

  return (
    <section className="pagina-produtos">
      <div className="produtos-apresentacao">
        <div className="produtos-apresentacao-info">
          <span className="secao-etiqueta">Nossa Loja</span>
          <h1>Produtos à pronta entrega</h1>
          <p>
            Cuias com virola de alpaca, esporas personalizadas e acessórios.
          </p>
        </div>
      </div>

      <div className="group">
        <svg className="icon" aria-hidden="true" viewBox="0 0 24 24">
          <g>
            <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z" />
          </g>
        </svg>
        <input
          type="search"
          className="input"
          placeholder="Pesquisar produtos..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="produtos-categorias">
        {categorias.map((cat) => (
          <button
            key={cat.chave}
            className={`produtos-categoria ${activeCategory === cat.chave ? "ativo" : ""}`}
            onClick={() => setActiveCategory(cat.chave)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="produtos-grid">
        {produtosFiltrados.map((p) => {
          const precoOriginal = Number(p.precoOriginal ?? p.preco ?? 0);
          const precoAtual = Number(p.preco ?? 0);
          const temDesconto = precoOriginal > precoAtual;

          return (
            <article
              key={p.id}
              className="card-produto produto-card"
              onClick={() => onOpenProduct(p.id)}
            >
              <div className="card-imagem-wrapper">
                {p.fotos?.[0] ? (
                  <img
                    className="card-imagem"
                    src={p.fotos[0]}
                    alt={p.nome}
                    loading="lazy"
                  />
                ) : (
                  <div className="card-placeholder">?</div>
                )}
                <span className="card-badge">{p.categoriaLabel}</span>
              </div>
              <div className="card-corpo">
                <span className="card-categoria">{p.categoriaLabel}</span>
                <h3 className="card-nome">{p.nome}</h3>
                <p className="card-descricao">
                  {(p.descricao || "").substring(0, 80)}...
                </p>
                <div className="card-rodape">
                  <div className="card-preco-group">
                    {temDesconto && (
                      <span className="card-preco-antigo">
                        R${" "}
                        {precoOriginal.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    )}
                    <div className="card-preco">
                      <span>R$</span>
                      {precoAtual.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                      })}
                    </div>
                  </div>
                  <button className="btn-detalhes">Ver detalhes</button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
